import { NumberOfClients, NumberOfEntities, PartnerStatus, ProductInterest, UseCase } from 'modules/data/domain';

import { messages } from '../../email/resources/messages';

export const partnerStatusLabels: Record<PartnerStatus, string> = {
    [PartnerStatus.XeroPlatinum]: messages.partnerStatusXeroPlatinum,
    [PartnerStatus.XeroGold]: messages.partnerStatusXeroGold,
    [PartnerStatus.XeroOther]: messages.partnerStatusXeroOther,
    [PartnerStatus.QBOPlatinum]: messages.partnerStatusQBOPlatinum,
    [PartnerStatus.QBOElite]: messages.partnerStatusQBOElite,
    [PartnerStatus.QBOOther]: messages.partnerStatusQBOOther,
    [PartnerStatus.OracleNetSuite]: messages.partnerStatusOracleNetSuite,
    [PartnerStatus.Hybrid]: messages.partnerStatusHybrid,
    [PartnerStatus.Other]: messages.partnerStatusOther,
};

export const productInterestLabels: Record<ProductInterest, string> = {
    [ProductInterest.Xero]: messages.productInterestXero,
    [ProductInterest.QuickBooksOnline]: messages.productInterestQuickBooksOnline,
    [ProductInterest.OracleNetSuite]: messages.productInterestOracleNetSuite,
    [ProductInterest.Cin7Core]: messages.productInterestCin7Core,
    [ProductInterest.Hybrid]: messages.productInterestHybrid,
    [ProductInterest.Other]: messages.productInterestOther,
};

export const numberOfEntitiesLabels: Record<NumberOfEntities, string> = {
    [NumberOfEntities.Less3]: messages.numberOfEntitiesLess3,
    [NumberOfEntities.Beetween3_10]: messages.numberOfEntitiesBeetween3_10,
    [NumberOfEntities.More10]: messages.numberOfEntitiesMore10,
};

export const numberOfClientsLabels: Record<NumberOfClients, string> = {
    [NumberOfClients.Beetween1_10]: messages.numberOfClientsBeetween1_10,
    [NumberOfClients.Beetween10_50]: messages.numberOfClientsBeetween10_50,
    [NumberOfClients.More50]: messages.numberOfClientsMore50,
};

export const useCaseLabels: Record<UseCase, string> = {
    [UseCase.StreamlineAuditProcesses]: messages.useCaseStreamlineAuditProcesses,
    [UseCase.EstablishInternalFinancialControls]: messages.useCaseEstablishInternalFinancialControls,
    [UseCase.AutomateApprovalWorkflows]: messages.useCaseAutomateApprovalWorkflows,
    [UseCase.SpeedupTheApprovalProcess]: messages.useCaseSpeedupTheApprovalProcess,
    [UseCase.Other]: messages.useCaseOther,
};

export const largePartnerByStatus = new Set([
    PartnerStatus.XeroPlatinum,
    PartnerStatus.XeroGold,
    PartnerStatus.QBOPlatinum,
    PartnerStatus.QBOElite,
    PartnerStatus.OracleNetSuite,
]);

export const largeBusinessByNumberOfEntities = new Set([NumberOfEntities.Beetween3_10, NumberOfEntities.More10]);

export const partnerStatusItems = Object.values(PartnerStatus).map((val) => ({
    id: val,
    text: partnerStatusLabels[val],
}));

export const numberOfEntitiesItems = Object.values(NumberOfEntities).map((val) => ({
    id: val,
    text: numberOfEntitiesLabels[val],
}));

export const numberOfClientsItems = Object.values(NumberOfClients).map((val) => ({
    id: val,
    text: numberOfClientsLabels[val],
}));

export const useCaseItems = Object.values(UseCase).map((val) => ({
    id: val,
    text: useCaseLabels[val],
}));
